import React from 'react'
import { Button, makeStyles, Box } from '@material-ui/core';
// import ShipSvg from '../svg/ShipSvg';

const useStyles = makeStyles((theme) => ({
    box: {
        position: 'relative',
    },
    icon: {
        position: 'absolute',
        top: 0,
        width: '35px',
        height: '35px',
        opacity: 1,
        left: 0,
        right: 0,
        bottom: 0,
        margin: 'auto',
        // transform: 'translate(0%, 100%)', 
        transform: 'translate(-300px)', 
        transition: 'all 1s',
    },
    button: {
        borderRadius: '50px',
        padding: '13px 35px 10px',
        lineHeight: '25px',
        // overflow: 'hidden',
        // '&::before': {
        //     content: '" "',
        //     position: 'absolute',
        //     width: 360,
        //     height: 320,
        //     borderRadius: 130,
        //     backgroundColor: theme.palette.primary.light,
        //     zIndex: 1,
        //     top: 100,
        //     left: '50%',
        //     transform: 'translate(-50%)',
        //     transition: 'all 1s',
        // },
        // '&:hover': {
        //     '&::before': {
        //         animation: '$wave 5s infinite linear',
        //         top: 50,
        //     },
        //     '& svg': {
        //         animation: '$sinking 4s linear',
              
        //     }
        // }
    },
    childrenBox: {
        position: 'relative',
        zIndex: 2,
    },
    "@keyframes wave": {
        "0%": {
            transform: "translate(-50%) rotate(0deg)",
        },
        "50%": {
            transform: "translate(-50%) rotate(120deg)",
        },
        "75%": {
            transform: "translate(-50%) rotate(45deg)",
        },
        "100%": {
            transform: "translate(-50%) rotate(0deg)",
        },
    },
    "@keyframes sinking": {
        "0%": {
            transform: 'translate(-300px)',
        },
        "30%": {
            transform: 'translate(0%)',
        },
        "40%": {
            transform: 'translate(0%)',
        },
        "60%": {
            transform: 'translate(0%) rotate(-45deg)',
        },
        "100%": {
            transform: 'translate(0%, 100%) rotate(-45deg)',
        }
    },
}))
const ButtonComponent = ({ children, color = 'primary', variant = 'contained', onClick = () => { } }) => {
    const classes = useStyles();

    return (
        <Box className={classes.box}>
            <Button className={classes.button} color={color} variant={variant} onClick={onClick}>
                <Box className={classes.childrenBox}>
                    {children}
                </Box>
                {/* <ShipSvg className={classes.icon} /> */}
            </Button>
        </Box>
    )
}


export default ButtonComponent;